import React from 'react';
import { Image, Text } from '@ui/atoms';
import { Button } from '@ui/atoms/design-system';

import { fdBookingSteps } from '@components/Products/FixedDeposits/utils/helper';
import FDBookingStep from '@components/Products/FixedDeposits/components/BookingSteps/FDBookingStep';
import { fdRedirectTo } from '../../utils/utils';
import useWindowDimensions from '@hooks/useWindowDimensions';
import { triggerCustomEvent } from '@helpers/miscelleanous';
import { fdProductEvents } from '@helpers/enums/gaEventNameEnum';

const FDBookingSteps = ({ toggleModal }) => {
    const { width } = useWindowDimensions();
    const isMobile = width < 768;
    const handleOnClick = () => {
        triggerCustomEvent(fdProductEvents.CLICKED_FD_PRODUCT_BOOK_NOW);

        isMobile ? fdRedirectTo() : toggleModal();
    };
    return (
        <section className="py-6 px-4 max-w-[1082px] w-full mx-auto md:py-18 flex flex-col gap-6 md:gap-8 lg:px-0">
            <Text
                content={fdBookingSteps.title}
                className="text-center p2-regular md:h3-regular"
                isInnerHtml
                htmlTag="h2"
            />
            <ul className="flex flex-col w-full gap-8 mx-auto md:mt-2 md:gap-12 md:flex-row md:flex-wrap sm:max-w-[320px] md:max-w-none sm:mx-auto">
                {fdBookingSteps.steps.map(({ step, description }) => (
                    <FDBookingStep
                        step={step}
                        description={description}
                        key={step}
                    />
                ))}
            </ul>
            <div className="flex flex-col items-center gap-6 sm:max-w-[320px] md:max-w-none sm:mx-auto">
                <div className="flex items-center justify-center gap-2">
                    <Image
                        src="/images/products/LightningGreen.svg"
                        className="w-5 h-5"
                    />
                    <Text
                        content={fdBookingSteps.note}
                        className="text-primary-500 p5-medium md:p4-medium"
                        htmlTag="p"
                    />
                </div>
                <Button
                    onClick={handleOnClick}
                    buttonText={fdBookingSteps.button}
                    buttonType="primary"
                    widthClass="w-full md:w-auto"
                />
            </div>
        </section>
    );
};

export default FDBookingSteps;
